<template>
<div>
  <v-card>
    <v-card-title>
      مدیریت سفارشات مستقیم
            <v-spacer/>
      <v-btn @click="createNewItem()" color="primary">ثبت سفارش مستقیم +</v-btn>
      </v-card-title>
      <v-divider></v-divider>
    <v-card-text>
  
  <trade-request-direct-list ref="TradeRequestDirectList"></trade-request-direct-list>

</v-card-text>
</v-card>
</div>
</template>

<script>
import TradeRequestDirectList from '@/modules/tradeRequests/components/TradeRequestDirectList.vue';
//import TradeRequestDirectForm from '@/modules/tradeRequests/components/TradeRequestDirectForm.vue';
//import TradeRequestDirectInformation from '../components/TradeRequestDirectInformation.vue';
export default {
  data() {
    return {};
  },
  components: {
    TradeRequestDirectList,
  },
  methods: {
    showDetailForm(){
      this.$store.commit('setTradeRequestSelectedForDisplay', null)
      this.$store.commit('setTradeRequestSingleItemForEdit', null)
      this.$store.commit('setTradeRequestItems', [])
      this.$store.commit('setTradeRequestSingleItem', null)
      this.$store.commit('setAllTradeRequests', [])
      this.$store.commit('setTradeRequestFormStatus', false)
      this.$store.commit('setTradeRequestEditMode', false)
      /////////
      this.$store.commit('setTradeRequestIsEdit', false)
      this.$store.commit('setTradeRequestShowDetailForm', true)
      this.$store.commit('setTradeRequestSelectedForEdit', null)

    },
    createNewItem(){
      this.$store.commit('setTradeRequestSelectedForDisplay', null)
      this.$store.commit('setTradeRequestSingleItemForEdit', null)
      this.$store.commit('setTradeRequestItems', [])
      this.$store.commit('setTradeRequestSingleItem', null)
      this.$store.commit('setAllTradeRequests', [])
      this.$store.commit('setTradeRequestEditMode', false)
      ///////
      this.$store.commit('setTradeRequestFormStatus', true)

      this.$store.commit('setTradeRequestIsEdit', false)
      this.$store.commit('setTradeRequestShowDetailForm', false)
      this.$store.commit('setTradeRequestSelectedForEdit', null)
      this.$router.push({path:'/trade-request-direct-form'})

    }
  },
};
</script>

<style></style>
